"use strict";

const SocketUtil = (function () {
    const MainPageControllerClass = function () {
        const _this = this;
        this.socket = null;
        this.debug = false;
        this.pageGuid = "";
        this.EventDic = {};
        this.Alone = false;
        this.AloneSessionID = null;
        this.AloneSocketState = null;
        this.ConnectTime = null;
        this.DisconnectTime = null;
        this.storageErrorCount = 0;
        // Task 991572: API Security Check: API tokens for RequireInstallation=False publishers should not be in the javascript.
        this.model = 1;
        let firstInit = true;
        let socketServerUrl = null;
        let timerHandler = null;
        const sendCallback = {};
        let sessionExpireCount = 0; // limit 10
        let connectCheckTimer = null;
        const apiUrl = document.domain;
        let timeoutConnectThread;
        let createGroupCache = {};
        let createGroupCacheTime = 0;

        this.TransferType = {
            Self: 0,
            All: 1,
            Other: 2,
            Room: 3,
            DistributorAll: 4,
            // Task 1033584: Echat SDK: Parament name is confuse
            CurrentDistributor: 4
        };

        this.Command = {
            Ping: 0,
            Message: 1,
            ReadGroupMessage: 2,
            WriteState: 3,
            GroupChange: 4,
            UserAvailability: 5,
            ScreenShare: 6,
            RTCMessage: 7,
            DeepLearning: 8,
            SupportGroup: 9,
            WMSMessage: 10, // WMS
            EDBLClient: 11, // EDBL
            WCSMessage: 12, // WCS
            WCSAlert: 13, // WCS
            TaskCustomerIDChange: 14,
            MessageRecalled: 15,
            ReadTask: 16,
            TaskChange: 17,
            HandoffMessage: 18, // DTC
            // Task 1146167: Create new echat message type
            PerformanceTest: 19 // Release Management
        };

        this.GroupType = {
            Silence: 0,
            System: 1,
            Message: 2,
            Support: 3,
            Task: 4
        };

        this.ErrorCode = {
            JsonError: -2,
            HttpError: -1,
            NoError: 0,
            LoginFailed: 1000,
            SessionExpire: 1001,
            ECPSessionExpire: 1002,
            ECPSessionError: 1003,
            NoPermission: 1004,
            ErrorData: 1005,
            ErrorParameter: 1006,
            NoAction: 1007,
            NoGroup: 1008,
            ActionError: 1009,
            RedisSaveError: 2000,
            RedisQueryError: 2001,
            SNSPushError: 3000,
            SNSReceiveError: 3001,
            SocketServerError: 4000,
            UpgradeDataError: 5000,
            UpgradeSaveError: 5001,
            ECP_APITimeOut: 7005
        };

        this.SocketState = {
            Expire: "expire",
            Connect: "connect",
            Reconnecting: "reconnecting",
            Reconnect: "reconnect",
            Disconnect: "disconnect",
            Error: "error"
        };

        this.ModelType = {
            ECPSession: 1,
            SocketSession: 2
        };

        const consoleError = function (message) {
            if (message !== null) {
                ECP.Dialog.Alert(message);
            }
        };

        const getTimeStamp = function () {
            return (new Date()).getTime();
        };

        const writeLocalStorage = function (key, value) {
            try {
                window.localStorage.setItem(key, value);
            } catch (e) {
                // Task 951021: JavaScript Error: includes/DefaultAll.min.js (1) - uncaught exception: QuotaExceededError. use 14.22KB
                if (e.name === "QuotaExceededError") {
                    if (_this.storageErrorCount < 2) {
                        _this.storageErrorCount++;
                        let sizeStore = 0;
                        if (window.localStorage) {
                            for (let i = 0, len = localStorage.length; i < len; i++) {
                                sizeStore += window.localStorage.getItem(window.localStorage.key(i)).length;
                            }
                        }

                        const tip = `eChat initialization failed(${_this.storageErrorCount}). Error: local storage quota exceeded(${(sizeStore / 1024).toFixed(2)}KB)`;
                        if (_this.storageErrorCount === 1) {
                            window.localStorage.clear();
                        } else {
                            _this.dispose(tip);
                        }
                    }
                } else {
                    throw e;
                }
            }
        };

        const refreshPageGuid = function () {
            if (!_this.Alone) {
                writeLocalStorage("PageGuid", _this.pageGuid);
            }
        };

        const trigger = function (event, args, isStorage) {
            if (_this.EventDic[event]) {
                const events = Object.values(_this.EventDic[event]);
                for (let i = 0, len = events.length; i < len; i++) {
                    events[i](args, isStorage);
                }
            }
        };

        const changeSocketState = function (state) {
            trigger(state, null, false);
            if (_this.Alone) {
                _this.AloneSocketState = state;
            } else {
                writeLocalStorage("SocketState", `${state}_${getTimeStamp()}`);
            }
        };

        const guid = function () {
            const s = [];
            const hexDigits = "0123456789abcdef";
            for (let i = 0; i < 36; i++) {
                const index = Math.floor(Math.random() * 0x10);
                s[i] = hexDigits.substring(index, index + 1);
            }
            s[14] = "4";
            const index = (s[19] & 0x3) | 0x8;
            s[19] = hexDigits.substring(index, index + 1);
            s[8] = "-";
            s[13] = "-";
            s[18] = "-";
            s[23] = "-";
            return s.join("");
        };

        const checkPageGuid = function () {
            if (_this.Alone) {
                return true;
            }
            return window.localStorage.getItem("PageGuid") === _this.pageGuid;
        };

        const getCookie = function (name) {
            const arr = document.cookie.match(new RegExp(`(^| )${name}=([^;]*)(;|$)`));
            if (arr) {
                return decodeURIComponent(arr[2]);
            }
            return null;
        };

        // Task 967961: eChat web servers are hitting the load balancers too frequently
        const getOldSessionID = function () {
            let SessionID = "";
            if (_this.Alone) {
                return SessionID;
            }
            try {
                const LastSocketInfoJson = window.localStorage.getItem("LastSocketInfo");
                if (LastSocketInfoJson) {
                    const LastSocketInfo = JSON.parse(LastSocketInfoJson);
                    if (LastSocketInfo?.SocketSessionID !== "Expire") {
                        const time = getTimeStamp() - LastSocketInfo.SessionTime;
                        const email = getCookie("Email");
                        const encompassSessionID = getCookie("EncompassSessionID");
                        // Task 985392: After switch the test site, no eChat messages can be received.
                        const encompassid = getCookie("EncompassID");
                        const currEncompassID = encompassid && encompassid === LastSocketInfo.EncompassID;
                        const currEmail = email && email === LastSocketInfo.Email;
                        if (currEncompassID && currEmail && encompassSessionID === LastSocketInfo.EncompassSessionID && time < 60 * 60 * 1000) {
                            SessionID = LastSocketInfo.SocketSessionID;
                        }
                    }
                }
            } catch (e) {
                // Error caught
            }

            return SessionID;
        };

        this.Reconnect = function (memo) {
            _this.dispose(`Reconnect: ${memo}`);
            refreshPageGuid();
            _this.webSocketConnect(`reconnect ${memo}`);
        };

        this.on = function (event, callback) {
            if (!_this.EventDic[event]) {
                _this.EventDic[event] = [callback];
            } else {
                _this.EventDic[event].push(callback);
            }
        };

        const getEChatServerUrl = function () {
            return new Promise(((resolve, reject) => {
                if (typeof (SocketServerUrl) !== "undefined") {
                    resolve(SocketServerUrl);
                } else {
                    const fun = function () {
                        const myRequest = new ECP.EC_Request(SalesComm_GetEChatNewServer);
                        myRequest.SetReturnType(ECP.EC_ReturnType.Json);
                        myRequest.Submit().then((jsonObj) => {
                            if (!jsonObj.errors && jsonObj.Url) {
                                window.SocketServerUrl = jsonObj.Url;
                                resolve(SocketServerUrl);
                            } else if (jsonObj.status && jsonObj.status === 401) {
                                changeSocketState(_this.SocketState.Expire);
                            } else {
                                reject({
                                    ErrorCode: jsonObj.errors[0].detail,
                                    Detail: `ajax error. ${jsonObj.errors[0].detail}`
                                });
                            }
                        });
                    }.catch((error) => {
                        reject({
                            ErrorCode: SocketUtil.ErrorCode.HttpError,
                            ErrorMessage: error.message
                        });
                    });
                    if (typeof (EWS) !== "undefined" && _this.model === _this.ModelType.ECPSession) {
                        EWS.Ready(() => {
                            EWS.VerifySession(() => {
                                fun();
                            });
                        });
                    } else {
                        fun();
                    }
                }
            }));
        };

        const refreshSocketSession = function (SocketSessionID) {
            if (_this.Alone) {
                _this.AloneSessionID = SocketSessionID;
            } else {
                writeLocalStorage("SocketSessionID", SocketSessionID);
                const email = getCookie("Email");
                const encompassid = getCookie("EncompassID");
                const encompassSessionID = getCookie("EncompassSessionID");
                if (SocketSessionID !== "Expire") {
                    writeLocalStorage("LastSocketInfo", JSON.stringify({
                        SessionTime: getTimeStamp(),
                        SocketSessionID,
                        Email: email,
                        EncompassID: encompassid,
                        EncompassSessionID: encompassSessionID
                    }));
                }
            }
        };

        const sessionExpireReconnect = function () {
            _this.dispose("sessionExpireReconnect");
            if (_this.model === _this.ModelType.ECPSession) {
                if (sessionExpireCount < 10) {
                    sessionExpireCount++;
                    setTimeout(() => {
                        _this.Reconnect("session expire reconnect.");
                    }, 1000);
                } else {
                    consoleError("Session Expire Limit 10");
                }
            }

            TriggerSessionExpireEvent("sessionExpireReconnect");
        };

        const TriggerSessionExpireEvent = function (memo) {
            try {
                trigger("SessionExpire", memo, false);
            } catch (e) {
                consoleError(e);
            }
        };

        this.api = function (action, data) {
            return new Promise(((resolve, reject) => {
                const formData = new FormData();
                if (data) {
                    const keys = Object.keys(data);
                    for (let i = 0, len = keys.length; i < len; i++) {
                        let postValue = data[keys[i]];
                        if (postValue === undefined || postValue === null) {
                            postValue = "";
                        }
                        formData.append(keys[i], postValue);
                    }
                }

                if (typeof (ECPVersion) !== "undefined") {
                    formData.append("ClientVersion", ECPVersion);
                }

                if (this.AloneSessionID) {
                    formData.append("AloneSessionID", true);
                }

                getEChatServerUrl().then((requestUrl) => {
                    if (!requestUrl) {
                        reject({
                            ErrorCode: SocketUtil.ErrorCode.HttpError,
                            ErrorMessage: "setting 549 is null"
                        });
                    }
                    if (action === "VerifySession") {
                        requestUrl += `?Action=${action}`;
                    } else {
                        const SocketSessionID = _this.getSessionID();
                        if (SocketSessionID === "Expire" || !SocketSessionID) {
                            // Task 1047426: Change message from Session Expire to Session Expired
                            consoleError(`${action}_Fail Session Expired`);
                            reject("Session Expired");
                            return;
                        }
                        requestUrl += `?SessionID=${SocketSessionID}&Action=${action}`;
                    }

                    fetch(requestUrl, {
                        cache: "no-store",
                        credentials: "same-origin",
                        method: "post",
                        body: formData
                    }).then((response) => {
                        response.json().then((jsonObj) => {
                            if (jsonObj.Status) {
                                resolve(jsonObj.Data);
                            } else {
                                switch (jsonObj.ErrorCode) {
                                    case SocketUtil.ErrorCode.ECPSessionExpire: // ECP session Expired
                                        if (_this.model === _this.ModelType.SocketSession) {
                                            TriggerSessionExpireEvent("ECPSessionExpire");
                                        } else if (typeof (EWS) !== "undefined") {
                                            EWS.Ready(() => {
                                                EWS.VerifySession();
                                            });
                                        }
                                        consoleError("ECP Session Expired");
                                        const SocketSessionID = _this.getSessionID();
                                        if (SocketSessionID !== "Expire") {
                                            changeSocketState(_this.SocketState.Expire);
                                        }

                                        reject({
                                            ErrorCode: jsonObj.ErrorCode,
                                            ErrorMessage: "Session Expired"
                                        });
                                        break;
                                    case SocketUtil.ErrorCode.SessionExpire:// EChat session Expired
                                        if (checkPageGuid() && _this.checkConnected()) {
                                            sessionExpireReconnect();
                                        } else {
                                            refreshSocketSession("Expire");
                                        }
                                        consoleError(`${action}_Fail Session Expired`);
                                        reject({
                                            ErrorCode: jsonObj.ErrorCode,
                                            ErrorMessage: "Session Expired"
                                        });
                                        break;
                                    default:
                                        consoleError(`${action}_Fail ajax error. ${jsonObj.ErrorCode} ${jsonObj.ErrorMessage} ${jsonObj.StackTrace}`);
                                        reject({
                                            ErrorCode: jsonObj.ErrorCode,
                                            ErrorMessage: jsonObj.ErrorMessage
                                        });
                                }
                            }
                        }).catch((error) => {
                            consoleError(error);
                            reject({
                                ErrorCode: SocketUtil.ErrorCode.JsonError,
                                ErrorMessage: error.message
                            });
                        });
                    }).catch((error) => {
                        reject({
                            ErrorCode: SocketUtil.ErrorCode.HttpError,
                            ErrorMessage: error.message
                        });
                    });
                }).catch((error) => {
                    reject({
                        ErrorCode: SocketUtil.ErrorCode.HttpError,
                        ErrorMessage: error.message
                    });
                });
            }));
        };

        this.createGroup = function (UserList, GroupType, DisableCache) {
            let promise;
            if (DisableCache || typeof (EC_Fmt) === "undefined" || typeof (EC_Fmt.MD5) === "undefined") {
                promise = _this.api("CreateMessageGroup2006", { UserList, GroupType });
            } else {
                // Task 1050785: CreateMessageGroup2006_Fail ajax error. 1012 Request rate is too fast
                promise = new Promise((resolve, reject) => {
                    if (UserList) {
                        const time = getTimeStamp();
                        if (time - createGroupCacheTime > 60000) {
                            createGroupCacheTime = time;
                            createGroupCache = {};
                        }

                        const md5 = EC_Fmt.MD5(UserList);
                        const cacheKey = `${md5}_${GroupType}`;
                        const MessageGroupKey = createGroupCache[cacheKey];
                        if (MessageGroupKey) {
                            resolve(MessageGroupKey);
                        } else {
                            _this.api("CreateMessageGroup2006", { UserList, GroupType }).then((data) => {
                                if (data) {
                                    createGroupCache[cacheKey] = data;
                                }
                                resolve(data);
                            }).catch((error) => {
                                reject(error);
                            });
                        }
                    } else {
                        reject("UserList is null");
                    }
                });
            }

            return promise;
        };

        // SendMessage
        this.send = function (messagePackage, success, fail) {
            if (!messagePackage || !messagePackage.MessageGroupID) {
                throw new Error("MessageGroupID is null");
            } else {
                if (!messagePackage.event_id) {
                    messagePackage.event_id = guid();
                }

                if (checkPageGuid()) {
                    if (_this.checkConnected()) {
                        try {
                            const messageObj = {
                                C: messagePackage.Command,
                                M: messagePackage.MessageBody,
                                G: messagePackage.MessageGroupID,
                                TC: Date.now(),
                                T: messagePackage.Transfer,
                                P: messagePackage.Push,
                                S: messagePackage.Save,
                                D: messagePackage.DataInfo
                            };

                            _this.socket.emit("message", messageObj, (ackMessage, error) => {
                                if (error) {
                                    if (typeof (fail) === "function") {
                                        fail(error.message);
                                    }
                                } else if (typeof (success) === "function") {
                                    if (ackMessage) {
                                        success({
                                            MessageID: ackMessage.I,
                                            TimeCreated: ackMessage.TC
                                        });
                                    } else {
                                        consoleError("ackMessage is null");
                                    }
                                }
                            });
                        } catch (e) {
                            if (typeof (fail) === "function") {
                                fail(e.message);
                            }
                            consoleError(e);
                        }
                    } else {
                        if (typeof (fail) === "function") {
                            // Task 739314: eChat Server: Change 'eChat Unconnected' error to 'eChat Disconnected'
                            fail("eChat Disconnected");
                        }
                        consoleError("eChat Disconnected");
                    }
                } else if (!messagePackage.isStorage) {
                    sendCallback[messagePackage.event_id] = { success, fail };
                    writeLocalStorage("SendMessage", JSON.stringify(messagePackage));
                }
            }
        };

        this.checkConnected = function () {
            if (_this.socket) {
                return _this.socket.connected;
            }
            return false;
        };

        // ManualDisconnection
        this.dispose = function () {
            if (_this.checkConnected()) {
                _this.socket.disconnect();
                // Task 921643: The Socket Disconnect event should not be triggered when the page is first opened
            } else if (_this.GetSocketState() !== _this.SocketState.Disconnect) {
                changeSocketState(_this.SocketState.Disconnect);
            }

            if (_this.socket) {
                _this.socket.destroy();
                _this.socket = null;
            }
        };

        this.getSessionID = function () {
            if (_this.Alone) {
                return _this.AloneSessionID;
            }
            return window.localStorage.getItem("SocketSessionID");
        };

        // Task 1111643: EChat panel displays 'Session Expire'.
        const getSocketSession = function () {
            return new Promise(((resolve, reject) => {
                const isGuest = getCookie("Guest");
                const encompassID = getCookie("EncompassID");
                const encompassDBServer = getCookie("EncompassDBServer");
                const encompassSessionID = getCookie("EncompassSessionID");
                let obj = {};
                let getOldSessionObj = {};
                if (encompassID && encompassID !== "") {
                    obj = {
                        EncompassDBServer: encompassDBServer,
                        EncompassSessionID: encompassSessionID,
                        EncompassID: encompassID,
                        Platform: 2
                    };
                    getOldSessionObj = {
                        EncompassDBServer: encompassDBServer,
                        EncompassSessionID: encompassSessionID,
                        EncompassID: encompassID,
                        SessionID: getOldSessionID(),
                        Platform: 2
                    };
                }
                if (_this.model === SocketUtil.ModelType.SocketSession) {
                    const connectionString = getCookie("SocketConnectionString");
                    const arr = connectionString ? connectionString.split("^") : [];
                    if (arr[0] && arr[1]) {
                        resolve({
                            SocketSessionID: arr[0],
                            SocketServerURL: arr[1]
                        });
                    } else {
                        changeSocketState(_this.SocketState.Expire);
                        reject({
                            ErrorCode: SocketUtil.ErrorCode.SessionExpire,
                            ErrorMessage: "Socket Session Empty"
                        });
                    }
                } else if (isGuest === "True") {
                    changeSocketState(_this.SocketState.Expire);
                    reject({
                        ErrorCode: SocketUtil.ErrorCode.ECPSessionExpire,
                        ErrorMessage: "Session Expired"
                    });
                } else if (typeof (EWS) !== "undefined") {
                    EWS.Ready(() => {
                        // Task 758601: After the Mac network is disconnected and reconnected, the eChat web client cannot automatically reconnect
                        if (!navigator.onLine) {
                            reject({
                                ErrorCode: SocketUtil.ErrorCode.HttpError,
                                ErrorMessage: "No Internet Connection"
                            });
                        } else {
                            EWS.VerifySession(() => {
                                _this.api("VerifySession", obj).then((config) => {
                                    resolve({
                                        SocketServerURL: config.SocketServerURL,
                                        SocketSessionID: config.SocketSessionID
                                    });
                                }).catch((e) => {
                                    reject(e);
                                });
                            });
                        }
                    });
                } else {
                    _this.api("VerifySession", getOldSessionObj).then((config) => {
                        resolve({
                            SocketServerURL: config.SocketServerURL,
                            SocketSessionID: config.SocketSessionID
                        });
                    }).catch((e) => {
                        reject(e);
                    });
                }
            }));
        };

        const getSocketIO = function () {
            return new Promise((resolve) => {
                if (typeof (io) !== "function") {
                    const script = document.createElement("script");
                    // Task 718597: eChat disconnected: socket.js does not load
                    script.src = "https://cdn.e8.co/GlobalDocs/socket.io.js";
                    script.onload = function () {
                        resolve();
                    };

                    const firstScript = document.getElementsByTagName("script")[0];
                    firstScript.parentNode.insertBefore(script, firstScript);
                } else {
                    resolve();
                }
            });
        };

        const bindEvent = function (SocketSessionID) {
            if (firstInit) {
                const onunloadFunction = window.onunload;
                window.onunload = function () {
                    if (checkPageGuid()) {
                        clearInterval(timerHandler);
                        timerHandler = null;
                        _this.dispose("onunload");

                        changeSocketState(_this.SocketState.Disconnect);
                        if (!_this.Alone) {
                            writeLocalStorage("SocketTimer", "");
                        }
                    }

                    if (typeof onunloadFunction === "function") {
                        return onunloadFunction();
                    }
                    return null;
                };
                firstInit = false;
            }

            _this.socket.on("message", (data) => {
                const message = {
                    MessageID: data.I,
                    Command: parseInt(data.C),
                    MessageBody: data.M,
                    MessageGroupID: data.G,
                    TimeCreated: data.TC,
                    Transfer: data.T,
                    Push: data.P,
                    Save: data.S,
                    DataInfo: data.D,
                    SenderAuthenticationID: parseInt(data.A)
                };

                if (message.DataInfo && message.DataInfo.SessionID && message.DataInfo.SessionID === _this.getSessionID()) {
                    return;
                }

                trigger("message", message, false);
                writeLocalStorage("SocketMessage", JSON.stringify(message));
            });

            _this.socket.on("error", (data) => {
                if (data && typeof (data) === "object" && data.code && data.code.toString().indexOf("ERR_SOCKETIO_INVALID") > -1) { // session
                    sessionExpireReconnect();
                } else {
                    consoleError(data);
                }
            });

            _this.socket.on("connect", () => {
                _this.ConnectTime = getTimeStamp();
                sessionExpireCount = 0;
                if (!checkPageGuid()) {
                    _this.dispose("checkPageGuid");
                    return;
                }
                refreshSocketSession(SocketSessionID);
                changeSocketState(_this.SocketState.Connect);
                if (!connectCheckTimer) {
                    connectCheckTimer = setInterval(() => {
                        if (checkPageGuid()) {
                            if (_this.GetSocketState() === SocketUtil.SocketState.Connect && !_this.checkConnected()) {
                                setTimeout(() => {
                                    if (checkPageGuid() && _this.GetSocketState() === SocketUtil.SocketState.Connect && !_this.checkConnected()) {
                                        changeSocketState(_this.SocketState.Disconnect);
                                    }
                                }, 2000);
                            }
                        } else {
                            clearInterval(connectCheckTimer);
                            connectCheckTimer = null;
                        }
                    }, 5000);
                }
            });

            _this.socket.on("disconnect", () => {
                _this.DisconnectTime = getTimeStamp();
                if (!checkPageGuid()) {
                    return;
                }

                changeSocketState(_this.SocketState.Disconnect);
                if (_this.getSessionID() === "Expire") {
                    changeSocketState(_this.SocketState.Expire);
                }
            });

            _this.socket.on("reconnect", () => {
                if (!checkPageGuid()) {
                    return;
                }
                changeSocketState(_this.SocketState.Reconnect);
            });

            _this.socket.on("reconnecting", () => {
                if (!checkPageGuid()) {
                    return;
                }
                changeSocketState(_this.SocketState.Reconnecting);
            });

            _this.socket.on("reconnect_failed", () => {
                if (_this.model === _this.ModelType.SocketSession) {
                    _this.dispose("reconnect_failed");
                    TriggerSessionExpireEvent("reconnect_failed");
                } else {
                    _this.Reconnect("reconnect failed.");
                }
            });

            _this.socket.on("anything", () => {
                // Does nothing
            });
        };

        this.webSocketConnect = function () {
            if (checkPageGuid()) {
                if (!_this.Alone) {
                    writeLocalStorage("SocketTimer", getTimeStamp());
                    if (!timerHandler) {
                        timerHandler = setInterval(() => {
                            if (checkPageGuid()) {
                                writeLocalStorage("SocketTimer", getTimeStamp());
                            }
                        }, 2000);
                    }
                }

                clearTimeout(timeoutConnectThread);
                getSocketSession().then((config) => {
                    getSocketIO().then(() => {
                        if (!_this.socket) {
                            _this.socket = io.connect(config.SocketServerURL, {
                                query: {
                                    token: config.SocketSessionID
                                },
                                reconnectionAttempts: 5
                            });
                            socketServerUrl = config.SocketServerURL;
                            refreshSocketSession(config.SocketSessionID);
                            bindEvent(config.SocketSessionID);
                        }
                    }).catch(() => {
                        changeSocketState(_this.SocketState.Error);
                    });
                }).catch((e) => {
                    switch (e.ErrorCode) {
                        case SocketUtil.ErrorCode.ECPSessionExpire:
                        case SocketUtil.ErrorCode.SessionExpire:
                            if (_this.model === SocketUtil.ModelType.SocketSession) {
                                TriggerSessionExpireEvent(e.ErrorMessage);
                            } else if (typeof (EWS) !== "undefined") {
                                // Task 656801: eChats: When sending eChats, I am getting a ! symbol
                                EWS.Ready(() => {
                                    EWS.VerifySession();
                                });
                            }

                            if (checkPageGuid()) {
                                changeSocketState(_this.SocketState.Expire);
                            }
                            break;
                        case SocketUtil.ErrorCode.HttpError:
                            timeoutConnectThread = setTimeout(() => {
                                _this.Reconnect("get session http error.");
                            }, 3000);
                            break;
                        case SocketUtil.ErrorCode.ECP_APITimeOut:
                            timeoutConnectThread = setTimeout(() => {
                                _this.Reconnect("Get session error. ECP api time out.");
                            }, 10000);
                            break;
                        default:
                            changeSocketState(_this.SocketState.Error);
                    }
                });
            }
        };

        this.checkSocket = function () {
            _this.debug = true;
            if (!checkPageGuid()) {
                writeLocalStorage("CheckSocket", getTimeStamp());
            } else {
                ECP.Dialog.Alert("Please check the console.");
                const connect = _this.checkConnected();

                if (connect) {
                    _this.createGroup([AuthenticationID], SocketUtil.GroupType.Silence).then((messageGroupInfo) => {
                        const messageGroupID = messageGroupInfo.MessageGroup.MessageGroupID;
                        _this.send({
                            Command: SocketUtil.Command.Ping,
                            MessageBody: "TestSend",
                            MessageGroupID: messageGroupID,
                            Transfer: SocketUtil.TransferType.Self,
                            Push: false,
                            Save: false
                        }, () => {
                            // Send Successful
                        });
                    }).catch((err) => {
                        consoleError(`${err.ErrorCode}:${err.ErrorMessage}`);
                    });
                }
            }
        };

        this.GetSocketState = function () {
            let SocketState = null;

            if (_this.Alone) {
                SocketState = _this.AloneSocketState;
            } else {
                const SocketStateStr = window.localStorage.getItem("SocketState");
                if (SocketStateStr) {
                    SocketState = SocketStateStr.split("_")[0];
                }
            }

            return SocketState;
        };

        const localStorageListener = function (origEvent) {
            const localStorageKey = origEvent.key;
            const localStorageNewValue = origEvent.newValue;
            if (localStorageNewValue && localStorageNewValue !== "" && localStorageNewValue !== origEvent.oldValue) {
                switch (localStorageKey) {
                    case "SocketState":
                        trigger(localStorageNewValue.split("_")[0], null, true);
                        break;
                    case "SocketMessage":
                        trigger("message", JSON.parse(localStorageNewValue), true);
                        break;
                    case "SendMessage":
                        if (checkPageGuid()) {
                            const messagePackage = JSON.parse(localStorageNewValue);
                            messagePackage.isStorage = true;
                            _this.send(messagePackage, (data) => {
                                writeLocalStorage("SendCallback", JSON.stringify({ state: true, event_id: messagePackage.event_id, data }));
                            }, (data) => {
                                writeLocalStorage("SendCallback", JSON.stringify({ state: false, event_id: messagePackage.event_id, data }));
                            });
                        }
                        break;
                    case "SendCallback":
                        const eventObj = JSON.parse(localStorageNewValue);
                        if (eventObj?.event_id && sendCallback[eventObj.event_id]) {
                            const callbackObj = sendCallback[eventObj.event_id];
                            if (eventObj.state && callbackObj.success) {
                                delete sendCallback[eventObj.event_id];
                                callbackObj.success(eventObj.data);
                            } else if (!eventObj.state && callbackObj.fail) {
                                delete sendCallback[eventObj.event_id];
                                callbackObj.fail(eventObj.data);
                            }
                        }

                        break;
                    case "SocketSessionID":
                        if (localStorageNewValue === "Expire" && checkPageGuid() && _this.checkConnected()) {
                            sessionExpireReconnect();
                        }

                        if (_this.checkConnected() && !checkPageGuid()) {
                            clearInterval(timerHandler);
                            timerHandler = null;
                            _this.dispose("SocketSessionID checkPageGuid");
                        }
                        break;
                    case "CheckSocket":
                        if (checkPageGuid()) {
                            _this.checkSocket();
                            window.localStorage.removeItem("CheckSocket");
                        }
                        break;
                    case "FindSocketTimer":
                        if (checkPageGuid()) {
                            writeLocalStorage("SocketTimer", getTimeStamp());
                            window.localStorage.removeItem("FindSocketTimer");
                        }
                        break;
                    case "LastSocketInfo":
                        if (_this.checkConnected() && !checkPageGuid()) {
                            clearInterval(timerHandler);
                            timerHandler = null;
                            _this.dispose("LastSocketInfo checkPageGuid");
                        }
                        break;
                }
            }
        };

        const getQueryString = function (name) {
            const r = window.location.search.substring(1, window.location.search.length - 1).match(new RegExp(`(^|&)${name}=([^&]*)(&|$)`, "i"));
            if (r) {
                return decodeURIComponent(r[2]);
            }
            return null;
        };

        const mainPageLost = function (memo) {
            if (!checkPageGuid()) {
                refreshPageGuid();
                writeLocalStorage("SocketTimer", getTimeStamp());

                const nowTime = getTimeStamp();
                // Task 737082: eChat take multiple minutes to load & display recent echats
                const random = Math.floor(Math.random() * 1500) + 1000;
                setTimeout(() => {
                    if (checkPageGuid()) {
                        _this.Reconnect(`${memo} Now Time: ${nowTime}.`);
                    }
                }, random);
            }
        };

        // Task 910650: Cannot echat
        const daemon = function () {
            if (!_this.Alone) {
                let enterTimer = false;
                setInterval(() => {
                    if (_this.storageErrorCount || enterTimer || checkPageGuid()) {
                        return;
                    }

                    let socketTimer = window.localStorage.getItem("SocketTimer");
                    const nowTime1 = getTimeStamp();

                    if (!socketTimer || nowTime1 - socketTimer < 0) {
                        mainPageLost("Socket page close.");
                    } else if (nowTime1 - socketTimer > 10000) {
                        writeLocalStorage("FindSocketTimer", nowTime1);
                        enterTimer = true;

                        setTimeout(() => {
                            const nowTime2 = getTimeStamp();
                            const limit = 8000 + nowTime2 - nowTime1;

                            socketTimer = window.localStorage.getItem("SocketTimer");
                            if (!socketTimer || nowTime2 - socketTimer < 0) {
                                mainPageLost("Socket page close.");
                            } else if (nowTime2 - socketTimer > limit) {
                                mainPageLost(`Socket page lost. Socket timer: ${socketTimer}.`);
                            }
                            enterTimer = false;
                        }, 2000);
                    }
                }, 1000);
            }
        };

        this.webSocketInit = function () {
            if (!_this.pageGuid || _this.pageGuid === "") {
                _this.pageGuid = guid();
            }
            if (!_this.Alone) {
                window.onstorage = localStorageListener;
            }
            _this.debug = getQueryString("DebugJs") === "true";
            if (!_this.debug) {
                _this.debug = getCookie("DebugJs") === "true";
            }

            const connectionString = getCookie("SocketConnectionString");
            if (connectionString) {
                _this.model = _this.ModelType.SocketSession;
            } else {
                _this.model = _this.ModelType.ECPSession;
            }

            // Session Expire
            const isGuest = getCookie("Guest");
            const SocketSessionID = _this.getSessionID();
            if ((_this.GetSocketState() === _this.SocketState.Expire || SocketSessionID === "Expire")) {
                if (_this.model === _this.ModelType.SocketSession) {
                    refreshPageGuid();
                    setTimeout(() => {
                        _this.webSocketConnect("web socket init.");
                    }, Math.floor(Math.random() * 500));
                } else if (isGuest !== "True") {
                    if (typeof (EWS) !== "undefined") {
                        EWS.Ready(() => {
                            EWS.VerifySession(() => {
                                refreshPageGuid();
                                setTimeout(() => {
                                    _this.webSocketConnect("ews ready.");
                                }, Math.floor(Math.random() * 500));
                            });
                        });
                    } else {
                        refreshPageGuid();
                        setTimeout(() => {
                            _this.webSocketConnect("web socket init.");
                        }, Math.floor(Math.random() * 500));
                    }
                }
            }

            // Log out
            if (_this.model === _this.ModelType.ECPSession && isGuest === "True") {
                refreshSocketSession("Expire");
            }

            // Socket timer
            daemon();

            // Session Expire
            if (typeof (EWS) !== "undefined" && _this.model === _this.ModelType.ECPSession) {
                EWS.VerifySessionFail(() => {
                    if (!_this.Alone) {
                        const SocketStateStr = window.localStorage.getItem("SocketState");
                        if (SocketStateStr) {
                            const SocketState = SocketStateStr.split("_")[0];
                            if (SocketState === _this.SocketState.Expire) {
                                return;
                            }
                        }
                        refreshSocketSession("Expire");
                    }
                    if (_this.checkConnected()) {
                        _this.dispose("VerifySessionFail");
                    }
                });

                // Re Login
                EWS.ReLogin(() => {
                    _this.Reconnect("ews relogin.");
                });
            }
        };

        if (window.parent === window && (typeof IsImpersonateUser === "undefined" || !IsImpersonateUser)) {
            if ((typeof (EC_Fmt) !== "undefined" && (getQueryString("AloneEChat") === "true")) || EC_Fmt.GetPageParameter("RunCodeItemTest") || EC_Fmt.GetPageParameter("PreviewCode")) {
                _this.Alone = true;
                _this.AloneSessionID = "Expire";
                _this.AloneSocketState = _this.SocketState.Expire;
            }

            // Task 713111: Gulfport: Mississippi will use the Encompass Cast devices for the monitor displays Need eChat from Dashboard that is logged in with QuickLink
            _this.webSocketInit();
        }
    };

    return new MainPageControllerClass();
}(Option));

SocketUtil.on("message", (data) => {
    if (typeof (EC_Fmt) !== "undefined" && data.Command === SocketUtil.Command.ScreenShare) {
        if (EC_Fmt.Browser === ECP.Browser.Chrome) {
            if (typeof ScreenShare === "undefined") {
                const script = document.createElement("script");
                script.src = "SalesCommunication/ScreenShare_INC.js";
                script.onload = function () {
                    ScreenShare.Client.handleScreenShareMessage(data.DataInfo);
                };

                document.head.appendChild(script);
            } else {
                ScreenShare.Client.handleScreenShareMessage(data.DataInfo);
            }
        } else if (EC_Fmt.Browser === ECP.Browser.Firefox) {
            if (typeof ScreenShare_Firefox === "undefined") {
                const script = document.createElement("script");
                script.src = "SalesCommunication/ScreenShareForFirefox.js";
                script.onload = function () {
                    ScreenShare_Firefox.Client.handleScreenShareMessage(data.DataInfo);
                };

                document.head.appendChild(script);
            } else {
                ScreenShare_Firefox.Client.handleScreenShareMessage(data.DataInfo);
            }
        } else if (SocketUtil.debug) {
            ECP.Dialog.Alert("This browser does not support screen sharing");
        }
    }
});
